import { Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import HistoryIcon from '@mui/icons-material/History';

export const PagingButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.button.primary.background,
  color: theme.palette.button.primary.color,
}));

export const HistoryIconStyled = styled(HistoryIcon)(({ theme }) => ({
  height: 100,
  width: 100,
  color: theme.palette.infoIcon,
}));

export const NoOrdersText = styled(Typography)({
  fontStyle: 'italic',
  color: 'gray',
  margin: '20px 0px',
});
